export default from './pagination.js';
export * from './pagination-classic.js';



// WEBPACK FOOTER //
// ./app/components/pagination/index.js